import React from 'react';
import { motion } from 'framer-motion';
export function Divider() {
  return <div className="w-full flex items-center justify-center py-16 opacity-70" data-id="element-17">
      <div className="h-[1px] w-24 bg-gradient-to-r from-transparent to-gold" data-id="element-18"></div>
      <motion.div initial={{
      rotate: 0
    }} whileInView={{
      rotate: 45
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} viewport={{
      once: true
    }} className="w-3 h-3 border border-gold mx-4 rotate-45" data-id="element-19"></motion.div>
      <div className="h-[1px] w-24 bg-gradient-to-l from-transparent to-gold" data-id="element-20"></div>
    </div>;
}